import React, {
  useContext, Children, isValidElement, cloneElement,
} from 'react';
import PropTypes from 'prop-types';
import { Button, makeStyles } from '@material-ui/core';
import { useTranslation } from 'utils/modifiedTranslation';
import { Sidebar, SidebarContext } from 'components/Sidebar';
import { StepperNavigation } from 'components/StepperNavigation';
import { SidebarFooter } from './components/Footer';

const useStyles = makeStyles(() => ({
  nextButton: {
    fontSize: 16,
    width: '100%',
    minHeight: 50,
    border: '1px solid #FF8C69',
    borderRadius: '20px',
    color: '#FF8C69',
    background: '#FFFFFF',
    marginTop: 14,
  },
}));

const QuestionnaireSidebarContent = ({
  stepsCount,
  isLastStep,
  isShowNext,
  activeStep,
  handleNext,
  handleBack,
  handleClose,
  children,
}) => {
  const isMultistepSidebar = stepsCount > 1;
  const { t } = useTranslation();
  const classes = useStyles();

  const sidebarState = useContext(SidebarContext);

  return (
    <>
      {isMultistepSidebar && (
        <StepperNavigation
          stepsNumber={stepsCount}
          onClose={handleClose}
          activeStep={activeStep}
          isMultistepSidebar={isMultistepSidebar}
        />
      )}
      {Children.map(children, (child) => {
        if (isValidElement(child)) {
          return cloneElement(child, { sidebarState });
        }
        return child;
      })}
      {isShowNext && (
        <Button
          color="primary"
          variant="text"
          onClick={handleNext}
          className={classes.nextButton}
        >
          {isLastStep
            ? t('questionnaire.questions.sidebar_button.submit')
            : t('questionnaire.questions.sidebar_button.next')}
        </Button>
      )}
      {activeStep !== 0 && isMultistepSidebar && (
        <SidebarFooter
          handleBack={handleBack}
          handleSkip={handleNext}
        />
      )}
    </>
  );
};

const contentPropTypes = {
  handleClose: PropTypes.func.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  stepsCount: PropTypes.number.isRequired,
  isShowNext: PropTypes.bool.isRequired,
  activeStep: PropTypes.number.isRequired,
  handleNext: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

QuestionnaireSidebarContent.propTypes = contentPropTypes;

export const QuestionnaireSidebar = ({
  isOpen = false,
  handleClose,
  children,
  ...restProps
}) => (
  <Sidebar
    isOpen={isOpen}
    handleClose={handleClose}
  >
    <QuestionnaireSidebarContent {...restProps} handleClose={handleClose}>
      {children}
    </QuestionnaireSidebarContent>
  </Sidebar>
);

QuestionnaireSidebar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  ...contentPropTypes,
};
